/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {Table} from 'react-bootstrap';
import {useGenericModelHooks, useShouldEditField} from "../../../Hooks/GenericModelHooks";
import * as renderers from "../RecordRenderers";

export function StandardModelViewerRenderer(props) {
    const {
        updateField,
        updateFields,
        getFieldDefs,
        sortFieldDefs
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const editMode = shouldEditField(props);

    const {
        EditMode,
        FieldDefinitionGroups,
        SkipBorder,
        RootData,
        Data,
        Validation,
        OnValidationUpdate,
        CustomData,
        IsNewModel,
        DefaultSelectedFieldDefKey,
        FieldGroup
    } = props;

    const className = (props?.className ?? "") + " sb-model-viewer " + (EditMode ? "editing " : "") + (SkipBorder ? "" : "table-bordered");

    return <Table className={className} striped size="sm">
        <tbody>
        {
            sortFieldDefs(FieldGroup?.value).map(fieldDef => {
                const FieldDefRenderer = renderers?.[fieldDef?.renderer ?? 'StandardModelViewerRecordRenderer'];
                
                if(typeof FieldDefRenderer !== 'function') {
                    console.log('invalid fieldDefRenderer', FieldDefRenderer);
                    return <b>{fieldDef?.renderer}</b>;
                }
                
                return <FieldDefRenderer
                    key={fieldDef?.key}
                    EditMode={editMode}
                    FieldDefinitionGroups={FieldDefinitionGroups}
                    FieldDef={fieldDef}
                    RootData={RootData}
                    Data={Data}
                    Validation={Validation?.[fieldDef?.key]}
                    UpdateField={updateField}
                    UpdateFields={updateFields}
                    GetFieldDefs={getFieldDefs}
                    OnValidationUpdate={OnValidationUpdate}
                    SkipBorder={SkipBorder}
                    CustomData={CustomData}
                    IsNewModel={IsNewModel}
                    DefaultSelectedFieldDefKey={DefaultSelectedFieldDefKey}
                />;
            })
        }
        </tbody>
    </Table>;
}
